import { PreQuerySizeGuideData } from '../types';
import {
  HOODIE_ILLUSTRATION_PATH,
  howToChooseSizeHoodieInstructions,
  internationalConversions,
} from './sharedSizeGuideData';

/**
 * Experience 5
 * Hoodie, Sweatshirt, Zipper Hoodie
 * fair-cuppa, jumping-boot, bonza-lamington
 * Data source: https://www.figma.com/file/APrcJzL2qFEoaRd5cHKcR6/Sizing---VM?node-id=102%3A1188&t=HmvOZ0xrFXTSRYSx-1
 */

export const experience5: PreQuerySizeGuideData = {
  internationalConversions,
  fitIndicator: {
    value: 2 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: HOODIE_ILLUSTRATION_PATH,
    instructions: howToChooseSizeHoodieInstructions,
  },
};
